
/* START_TEMPLATE */
define('hbs!app/templates/fieldset',['hbs','Handlebars', 'hbs!app/templates/_rows'], function( hbs, Handlebars ){ 
var t = Handlebars.template({"1":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return "<div class=\"at-subtitle\">"
    + escapeExpression(((helper = (helper = helpers.subTitle || (depth0 != null ? depth0.subTitle : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"subTitle","hash":{}}) : helper)))
    + "</div>";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1, helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, buffer = "<legend class=\"at-legend\">"
    + escapeExpression(((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"title","hash":{}}) : helper)))
    + "</legend>\n";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.subTitle : depth0), {"name":"if","hash":{},"fn":this.program(1, data),"inverse":this.noop});
  if (stack1 != null) { buffer += stack1; }
  buffer += "<div class=\"at-fields\">\n";
  stack1 = this.invokePartial(partials['./_rows'], '  ', './_rows', depth0, undefined, helpers, partials);
  if (stack1 != null) { buffer += stack1; }
  return buffer + "</div>\n";
},"usePartial":true});
Handlebars.registerPartial('app/templates/fieldset', t);
return t;
});
/* END_TEMPLATE */
;
